import io from 'socket.io-client';

let socket = {};

const initSocket = () => {
  // socket = io('wss://47.97.214.92:8443/websocket');
  //socket = io('wss://121.199.75.153:28443/websocket/Admin');
  socket = io('wss://121.199.75.153:18445/websocket/Admin');
};

const connectSocket = () => {
  socket.on('connect', message => {
  });
};

export default {
  socket,
  initSocket,
  connectSocket
};
